import { Base } from '@studiometa/js-toolkit';
import { addClass, removeClass, addStyle } from '@studiometa/js-toolkit/utils';

/**
 * Homepage class.
 */
export default class MenuItem extends Base {
  open = false;

  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'MenuItem',
    refs: ['submenu', 'child-arrow'],
  };

  /**
   * Click on Item with submenu
   * @param {object} props Props
   * @param {object} props.event current event
   * @returns {void}
   */
  onClick({ event }) {
    if (window.innerWidth < 1024) {
      const submenu = Array.isArray(this.$refs.submenu)
        ? this.$refs.submenu[0]
        : this.$refs.submenu;
      const isFromSubmenu = submenu && submenu.contains(event.target);

      if (isFromSubmenu) {
        return;
      }

      event.preventDefault();

      if (!this.open) {
        this.openSubmenu();
      } else {
        this.closeSubmenu();
      }
    }
  }

  /**
   * Open menu nothing more
   * @returns {void}
   */
  openSubmenu() {
    if (this.open) return;
    // @ts-ignore
    if (this.$parent && typeof this.$parent.closeAllSubmenus === 'function') {
      // @ts-ignore
      this.$parent.closeAllSubmenus();
    }

    if (this.$parent) {
      // @ts-ignore
      this.$parent.submenuOpen = true;
    }

    const submenu = Array.isArray(this.$refs.submenu) ? this.$refs.submenu[0] : this.$refs.submenu;
    if (submenu) {
      const realHeight = submenu.scrollHeight;
      addStyle(submenu, { maxHeight: `${realHeight}px` });
      addClass(submenu, 'submenu--active');
    }
    this.open = true;
    removeClass(this.$refs.childArrow, 'rotate-90');
    addClass(this.$refs.childArrow, '-rotate-90');
  }

  /**
   * Close menu nothing more
   * @returns {void}
   */
  closeSubmenu() {
    const submenu = Array.isArray(this.$refs.submenu) ? this.$refs.submenu[0] : this.$refs.submenu;
    if (submenu) {
      addStyle(submenu, { maxHeight: '0' });
      removeClass(submenu, 'submenu--active');
    }
    this.open = false;
    if (this.$parent) {
      // @ts-ignore
      this.$parent.submenuOpen = false;
    }
    removeClass(this.$refs.childArrow, '-rotate-90');
    addClass(this.$refs.childArrow, 'rotate-90');
  }
}
